module.exports = __webpack_public_path__ + "static/media/258-mongolia.34205f2a.svg";